import { Component, OnInit, ViewChild, ElementRef, Renderer2, ViewChildren, QueryList, ChangeDetectorRef } from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { NgbModal, ModalDismissReasons, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { logbaseService } from "../../services/logbase.service";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { DatePipe } from '@angular/common';
import { MatTableDataSource, } from "@angular/material/table";
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
export interface SupplierCodeData{
  supplierCode:any;
  unlisted:ElementRef;
}

class supplierCodeList{
  supplierCode:string;
  supplierNameEN:string;
  supplierNameJP:string;
  contract:string;
  supplierClassification:string;
  loginId:string;

}

@Component({
  selector: "app-supplier-code",
  templateUrl: "./supplier-code.component.html",
  styleUrls: ["./supplier-code.component.scss"]
})
export class SupplierCodeComponent implements OnInit {

  SupplierResult: any;
  supplierCodedata: any[] = [];
  supplierTypeEdit: any;
  type: any;
  locationType: any;
  supplierType: any;
  userIDTaken: boolean;
  missingCode: any;
  newSupplierCodeEdit: any;
  suppNameEngEdit: any;
  suppNameJapEdit: any;
  contractEdit: any;
  supplierDetails: any;
  triggerSupplierCodeList: boolean = false;
  loginId: any;
  contract: any;
  // type: any;
  suppNameJap: any;
  suppNameEng: any;
  newSupplierCode: any;
  supplierCodeList: supplierCodeList[]=[
    {
    supplierCode:'',
    supplierNameEN:'',
    supplierNameJP:'',
    contract:'',
    supplierClassification:'',
    loginId:''
  }
]
  SuppCodeData: any;
  @ViewChild("createNav") createNav: ElementRef;
  @ViewChild("createPane") createPane: ElementRef;
  @ViewChild("unlistNav") unlistNav: ElementRef;
  @ViewChild("unlistPane") unlistPane: ElementRef;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<any>;
  dtTriggerUnlisted: Subject<any> = new Subject();
  dtTrigger: Subject<any> = new Subject();
  dtOptions: DataTables.Settings[] = [];
  paidOpt: string[] = ["Fuso", "Supplier"];
  locationOpt: string[] 
  modalRef: NgbModalRef;
  public rows: Array<any> = [];
  datePipe = new DatePipe("en-US");
  public page: number = 1;
  public itemsPerPage: number = 100;
  public maxSize: number = 100;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;
  private data: Array<any> = [];
  dataSource: MatTableDataSource<SupplierCodeData[]>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  srchValue:any;

  displayedColumns:any[]=['supplierCode','unlisted']

  constructor(
    private modalService: NgbModal,
    private logbaseService: logbaseService,
    private ref: ChangeDetectorRef,
    private toaster: ToastrService,
    private renderer: Renderer2,
    private spinner: NgxSpinnerService,
    private translate: TranslateService
  ) {
    this.locationOpt= [this.translate.instant("Overseas supplier"), this.translate.instant("Local supplier")];
    this.columns= [
      { title: this.translate.instant("SUPPLIERCODE"), name: "supplierCode" },
      { title: this.translate.instant('Unlisted'), name: "unlisted" }
    ];
    this.config= {
      paging: true,
      sorting: { columns: this.columns },
      filtering: { filterString: "" },
      className: ["table-striped", "table-bordered"]
    };
   }



  public columns: Array<any> 
  public config: any 

  ngOnInit() {
    this.dtOptions[0] = {
      pagingType: "simple_numbers",
      dom:
        '<"top"<"row"<"col-md-7 text-right"<"#dtpagination"p>><"col-md-5 text-right"<"#dtlength"l>><"clear">>><"#dtSearch_unlistVSCode"f>t<"bottom"<"clear">>',
      // order: [[3, "desc"]],
      language: {
        search: "_INPUT_",
        searchPlaceholder: this.translate.instant('Search by Supplier Code'),
        paginate: {
          first: "",
          last: "",
          previous: "<",
          next: ">"
        }
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        $("td", row).unbind("click");
        $("td", row).bind("click", () => { });
        return row;
      }
    };

    this.dtOptions[1] = {
      pagingType: "simple_numbers",
      pageLength: 10,
      dom:
        '<"top"<"row"<"col-md-7 text-right"<"#dtpagination"p>><"col-md-5 text-right"<"#dtlength"l>><"clear">>><"#dtSearch_adminSuppCode"f>t<"bottom"<"clear">>',
      language: {
        emptyTable: this.translate.instant('No Records Found'),
        search: "_INPUT_",
        searchPlaceholder: this.translate.instant("Search by Supplier Code"),
        paginate: {
          first: "",
          last: "",
          previous: "<",
          next: ">"
        }
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        // Unbind first in order to avoid any duplicate handler
        // (see https://github.com/l-lin/angular-datatables/issues/87)
        $("td", row).unbind("click");
        $("td", row).bind("click", () => { });
        return row;
      }
    };
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    this.loginId = userDetJson.loginId;
    // this.spinner.show();
    this.onChangeTable(this.config, true);

    this.logbaseService.getSupplierCode().subscribe(result => {
      this.supplierCodeList = result.response;
      this.dtTrigger.next(true);
    });
  }

  pagination(event:any)
  {
    var dataToSend = {
      pageNum: event.pageIndex,
      searchValue: this.config.filtering.filterString,
      size: event.pageSize,
     
    };

    this.spinner.show();
    this.logbaseService
      .missingSupplierCodePaginated(dataToSend)
      .subscribe(result => {
        this.missingCode = result;
        var partArr;
        var partsData = [];

        this.missingCode.response.content.forEach(function (value, key) {
          partArr = {
            supplierCode: value.supplierCode,
            unlisted: '<div class="text-center hasLink">Click to Add Supplier Code</div>'
          };
          partsData.push(partArr);
        });

        this.supplierCodedata = partsData;
        this.dataSource=new MatTableDataSource<SupplierCodeData[]>(this.supplierCodedata);

        this.data = partsData;
        this.length = this.missingCode.response.totalElements;
      })
  }

  navigateTab(data) {
    const navFirst = this.unlistNav.nativeElement;
    const paneFirst = this.unlistPane.nativeElement;
    const navSecond = this.createNav.nativeElement;
    const paneSecond = this.createPane.nativeElement;

    this.renderer.setAttribute(navFirst, "class", "nav-link");
    this.renderer.setAttribute(paneFirst, "class", "tab-pane");
    this.renderer.setAttribute(navSecond, "class", "nav-link active");
    this.renderer.setAttribute(paneSecond, "class", "tab-pane active");
    this.newSupplierCode = data;

    // Navigate to top of the page
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  valuechange(newValue) {
    this.newSupplierCode = newValue;
    if (newValue.length > 0) {
      this.logbaseService.getSupplierCodeDetail(newValue).subscribe(
        data => {
          // set success message and pass true paramater to persist the message after redirecting to the login page
          if (data.response == "Response is empty") {
            document.getElementById("mytext").innerHTML = " ";
            this.userIDTaken = false;
          } else {
            document.getElementById("mytext").innerHTML =
              "Supplier Code Already Taken";
            this.userIDTaken = true;
          }
        },
        error => {
          this.postFormError();
        }
      );
    } else {
      this.userIDTaken = false;
      document.getElementById("mytext").innerHTML = " ";
    }
  }

  postFormError() {
    this.toaster.warning(
      this.translate.instant("NETWORK_STATUS_ISSUE")
    );
  }

  // openConfirmBox(addSuppCode) {
  //   this.modalRef = this.modalService.open(addSuppCode);
  //   this.modalRef.result.then(result => { });
  // }

  addSupplierCode(f) {

    if (confirm("Do you want to add new Supplier Code?")) {

      var newSupplierCodeData = {
        supplierCode: this.newSupplierCode,
        supplierNameEN: this.suppNameEng,
        supplierNameJP: this.suppNameJap,
        contract: this.contract,
        supplierClassification: this.type,
        loginId: null,
        supplierManagerQs: [],
        supplierManagerVSs: [],
        logistics: [],
        operations: [],
        createdDate: null,
        createBy: this.loginId,
        updatedDate: null,
        updatedBy: this.loginId
      };
      this.spinner.show();
      let Updatedata = {
        missing: false,
        supplierCode: this.newSupplierCode
      };
      this.logbaseService
        .addSupplierCode(newSupplierCodeData)
        .subscribe(response => {
          this.logbaseService
            .updateMissingSupplierCode(Updatedata)
            .subscribe(result => {
              this.toaster.success(
                this.translate.instant('SUPPLIERCODE') + this.newSupplierCode + this.translate.instant('CreatedSuccessfully')
              );
              this.rerender();
              this.spinner.hide();
              f.resetForm();
            });
        });
    } else {
      return false;
    }
  }

  editRowDetails(editDetails, data) {
    this.newSupplierCodeEdit = data.supplierCode;
    this.suppNameEngEdit = data.supplierNameEN;
    this.suppNameJapEdit = data.supplierNameJP;
    this.contractEdit = data.contract;
    this.supplierTypeEdit = data.supplierClassification;

    this.modalRef = this.modalService.open(editDetails,{backdrop:false});
    this.modalRef.result.then(result => { });
  }
  suppNameEngEditChange(newValue) {
    if (newValue.length > 0) {
      document.getElementById("EN").innerHTML = "";
    }
  }
  suppNameJpEditChange(newValue) {
    if (newValue.length > 0) {
      document.getElementById("JP").innerHTML = "";
    }
  }
  saveChanges() {
    if (this.suppNameEngEdit != null && this.suppNameJapEdit != null) {
      document.getElementById("EN").innerHTML = "";
      document.getElementById("JP").innerHTML = "";
      this.spinner.show();
      var newSupplierCodeEdited = {
        supplierCode: this.newSupplierCodeEdit,
        supplierNameEN: this.suppNameEngEdit,
        supplierNameJP: this.suppNameJapEdit,
        contract: this.contractEdit,
        supplierClassification: this.supplierTypeEdit,
        loginId: null,
        supplierManagerQs: [],
        supplierManagerVSs: [],
        logistics: [],
        operations: [],
        createdDate: null,
        createBy: this.loginId,
        updatedDate: null,
        updatedBy: this.loginId
      };
      this.logbaseService
        .editSupplierCode(newSupplierCodeEdited)
        .subscribe(response => {
          this.toaster.success(
            this.translate.instant('SUPPLIERCODE') + this.newSupplierCodeEdit + this.translate.instant('savedSuccess')
          );
          this.rerender();
          this.modalRef.close();
          this.spinner.hide();
        });
    }
    if (this.suppNameEngEdit == null || this.suppNameJapEdit == null) {
      if (this.suppNameEngEdit == null) {
        document.getElementById("EN").innerHTML =
          this.translate.instant("Supplier Name EN can't be empty");
      }
      if (this.suppNameJapEdit == null) {
        document.getElementById("JP").innerHTML =
          this.translate.instant("Supplier Name JP can't be empty");
      }
    } else {
      document.getElementById("EN").innerHTML = "";
      document.getElementById("JP").innerHTML = "";
    }
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender() {
    this.dtElements.forEach((dtElement: DataTableDirective, index: number) => {
      dtElement.dtInstance.then((dtInstance: any) => {
        // Destroy the table first
        dtInstance.destroy();
      });
    });
    // this.logbaseService.getMissingSupplierCodes().subscribe(
    //   result => {
    //     this.missingCode = result.response
    //     this.dtTriggerUnlisted.next();
    //   });
    this.logbaseService.getSupplierCode().subscribe(result => {
      this.supplierCodeList = result.response;
      this.dtTrigger.next(true);
    });
  }
  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== "" && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === "desc" ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === "asc" ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(
          this.config.filtering.filterString
        )
      );
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (
          item[column.name].toString().match(this.config.filtering.filterString)
        ) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    var pageNo;
    var sortData;

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort != "") {
        sortData = {
          name: value.name,
          sort: value.sort
        };
      }
    });

    var dataToSend = {
      pageNum: pageNo,
      searchValue: this.srchValue,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort
    };

    this.spinner.show();
    this.logbaseService
      .missingSupplierCodePaginated(dataToSend)
      .subscribe(result => {
        this.missingCode = result;
        var partArr;
        var partsData = [];

        this.missingCode.response.content.forEach(function (value, key) {
          partArr = {
            supplierCode: value.supplierCode,
            unlisted: '<div class="text-center hasLink">Click to Add Supplier Code</div>'
          };
          partsData.push(partArr);
        });

        this.supplierCodedata = partsData;
        this.dataSource=new MatTableDataSource<SupplierCodeData[]>(this.supplierCodedata);

        this.data = partsData;
        this.length = this.missingCode.response.totalElements;

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.rows =
          page && config.paging
            ? this.changePage(page, sortedData)
            : sortedData;
        //this.length = sortedData.length;

        this.rerenderTable(this.config, true);
        this.ref.detectChanges();
        this.spinner.hide();
      });
  }

  public rerenderTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);

    this.rows =
      page && config.paging ? this.changePage(page, sortedData) : sortedData;
    //this.length = sortedData.length;
  }

  exportCSV() {
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      // showTitle: true,
      title: 'Supplier Code List',
      headers: ['Supplier Code', 'Supplier Name[Eng]', 'Supplier Name[Jap]', 'Paid By', 'Supplier Type', 'Users are registered']
    };
    var csvData = [];
    var csvJson = {};

    this.supplierCodeList.forEach(value => {
      csvJson = {
        supplierCode: null!=value.supplierCode && !(value.supplierCode.startsWith("=")
        ||value.supplierCode.startsWith("+") || value.supplierCode.startsWith("-") || value.supplierCode.startsWith("@"))?value.supplierCode:'',
        supplierNameEN: null!=value.supplierNameEN && !(value.supplierNameEN.startsWith("=")
        || value.supplierNameEN.startsWith("+") || value.supplierNameEN.startsWith("-") || value.supplierNameEN.startsWith("@"))?value.supplierNameEN:'',
        supplierNameJP: null!=value.supplierNameJP && !(value.supplierNameJP.startsWith("=") || value.supplierNameJP.startsWith("+")
        || value.supplierNameJP.startsWith("-") || value.supplierNameJP.startsWith("@"))?value.supplierNameJP:'',
        contract: null!=value.contract && !(value.contract.startsWith("=") || value.contract.startsWith("+")
        || value.contract.startsWith("-") || value.contract.startsWith("@"))?value.contract:'',
        supplierClassification: null!=value.supplierClassification && !(value.supplierClassification.startsWith("=")
        || value.supplierClassification.startsWith("+") || value.supplierClassification.startsWith("-")
        || value.supplierClassification.startsWith("@"))?value.supplierClassification:''
      }
      Object.assign(csvJson, value.loginId ? { loginId: 'Yes' } : { loginId: 'No' });
      csvData.push(csvJson);
    });
    new AngularCsv(csvData, 'Supplier Code', options);
    this.modalRef.close();
    this.toaster.success(
      this.translate.instant('SUP_CODE_EXPORTED')
    );
  }

  openExport(exportModal) {
    this.modalRef = this.modalService.open(exportModal,{backdrop:false});
    this.modalRef.result.then((result) => {
    });
  }

}
